export default {
  breadcrumb: {
    home: 'Home',
    catalog: 'Catalog',
  },
  header: {
    heading: 'Browse games',
    subtitle1: '12,400+ verified keys sourced directly from authorized distributors.',
    subtitle2: 'Secure your next adventure.',
  },
  search: {
    placeholder: 'Search by title, publisher, or genre...',
  },
  filters: {
    heading: 'Filters',
    clearAll: 'Clear all',
    close: 'Close filters',
    open: 'Open filters',
    apply: 'Apply Filters',
    category: 'Category',
    platform: 'Platform',
    priceRange: 'Price range',
    showLess: '− Show less',
    showMore: '+ Show {count} more',
    ariaLabel: 'Filters',
  },
  results: {
    count: 'no results | {n} result | {n} results',
  },
  sort: {
    label: 'Sort by:',
    priceAsc: 'Price ↑',
    priceDesc: 'Price ↓',
    newest: 'Newest',
    nameAsc: 'Name A–Z',
    relevance: 'Relevance',
  },
  view: {
    grid: 'Grid view',
    list: 'List view',
  },
  pagination: {
    prev: 'Previous page',
    next: 'Next page',
    ariaLabel: 'Pagination',
  },
  empty: 'No products match your filters.',
  loading: 'Loading…',
  card: {
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    unavailable: 'Unavailable',
    preorder: 'Pre-order',
    includesDlc: 'Includes DLC',
    startingFrom: 'Starting from',
    was: 'Was',
    from: 'From',
    delisted: 'Delisted',
    offersCount: '{count} offers',
    view: 'View',
    details: 'Details',
  },
};
